import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Runner = /*#__PURE__*/function () {
  function Runner(name) {
    _classCallCheck(this, Runner);
    this.items = [];
    this._name = name;
    this._aliasCount = 0;
  }
  _createClass(Runner, [{
    key: "emit",
    value: function emit(a0, a1, a2, a3, a4, a5, a6, a7) {
      if (arguments.length > 8) {
        throw new Error("max arguments reached");
      }
      var name = this.name,
        items = this.items;
      this._aliasCount++;
      for (var i = 0, len = items.length; i < len; i++) {
        items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
      }
      if (items === this.items) {
        this._aliasCount--;
      }
      return this;
    }
  }, {
    key: "ensureNonAliasedItems",
    value: function ensureNonAliasedItems() {
      if (this._aliasCount > 0 && this.items.length > 1) {
        this._aliasCount = 0;
        this.items = this.items.slice(0);
      }
    }
  }, {
    key: "add",
    value: function add(item) {
      if (item[this._name]) {
        this.ensureNonAliasedItems();
        this.remove(item);
        this.items.push(item);
      }
      return this;
    }
  }, {
    key: "remove",
    value: function remove(item) {
      var index = this.items.indexOf(item);
      if (index !== -1) {
        this.ensureNonAliasedItems();
        this.items.splice(index, 1);
      }
      return this;
    }
  }, {
    key: "contains",
    value: function contains(item) {
      return this.items.includes(item);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.ensureNonAliasedItems();
      this.items.length = 0;
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAll();
      this.items = null;
      this._name = null;
    }
  }, {
    key: "empty",
    get: function get() {
      return this.items.length === 0;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }]);
  return Runner;
}();
Object.defineProperties(Runner.prototype, {
  dispatch: {
    value: Runner.prototype.emit
  },
  run: {
    value: Runner.prototype.emit
  }
});
export { Runner };